export const zhCN = {
  translation: {
    header: {
      title: "你好",
      tips_one: "页面已被浏览{{count}}次",
      tips_other: "页面已被浏览{{count}}次",
      tips_zero: "暂无浏览",
    },
    date: "今天是{{date, DATE_HUGE}}",
  },
};
